/* eslint-disable import/extensions */
/* eslint-disable no-console */
/* eslint-disable max-len */
import { Checkbox, Menu, TableCell, TableRow } from '@mui/material';
import React, { useState, useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { BsFolder } from 'react-icons/bs';
import { MuiPaperPropsStyles, medaiDriveDateDiff } from '../../../../../libs/HelperContent';
import { LanguageContext } from '../../../../../libs/Context';
import ReactPlayer from 'react-player';
import '../../../style.css';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import ListMenu from '../../CustomMenu/ListMenu';
import { useParams } from 'react-router-dom';
import { MediaContext } from '../../..';
import MoveToFolder from '../../MoveToFolder';
import SharedInfo from './SharedInfo';
import { RiDeleteBinLine } from 'react-icons/ri';
import GroupUserSvgIcon from '../../../../../assets/SvgIcons/GroupUserSvgIcon';
import { MdOutlineFolderZip } from 'react-icons/md';
import RestorePopup from '../../../popups/RestorePopup';
import DeletePopUp from '../../../Common/DeletePopUp/DeletePopUp';
import MoveToTrashPopUp from '../../../Common/MoveToTrashPopUp/MoveToTrashPopUp';
import RenameFolder from './RenamePopUp';
import { useSelector } from 'react-redux';
import CommonVariableAndFunc from './CommonVariableAndFunc';
import SelectTemplate from '../../CustomEdmTemplates/SelectTemplate';
import CreationFieldPopUp from '../../../../NewsFeedRevised/Components/LeftPart/FeedCreation/CreationPopup';

const ListCard = (props:any) =>

{
	const { data, handleCheckBox, handleClickFolder, openShare,
		getFoldersData, getTrashDataInfo, isSelected } = props;
	const [ optionsData, setOptionsData ] = useState<any>({});
	const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ popups, setPopups ] = useState<any>({
		move      : false,
		restore   : false,
		rename    : false,
		share     : false,
		trash     : false,
		delete    : false,
		customize : false
	});
	const [ mediaDrivePopup, setMediaDrivePopup ] = useState<any>([]);
	const { handleClose, handleOptions, fileType, extensionformat, documentCheck, defaultCheck } = CommonVariableAndFunc(data, setOptionsData, setAnchorEl);
	const { mediaState, tab, setClickedData } = useContext(MediaContext);
	const clickedUser = useParams()?.userId || '';
	let shareArr:any;

	const handlePopup = (item) =>
	{
		setAnchorEl(null);
		setPopups({ ...popups, ...item });
	};

	if (userData?.empRole === 'employee')
	{
		shareArr = data?.shareTo?.filter((item:any) => item?.access !== 1 && (item?.type === 'employee' || item?.type === 'company internal employees'));
	}
	else
	{
		shareArr = data?.shareTo?.filter((item:any) => item?.access !== 1);
	}

	const deletionDate:any = new Date(data?.trashAt);

	const futureDate:any = new Date(deletionDate);

	futureDate.setDate(deletionDate.getDate() + 30);

	const presentTime:any = new Date();
	const remainingDays = Math.ceil((futureDate - presentTime) / (1000 * 60 * 60 * 24));

	return (

		<>
			<TableRow
				hover
				tabIndex={-1}
				selected={isSelected?.includes(data?.folderId)}
			>
				{([ 0, 1, 3, 4 ]?.includes(tab) || (tab === 2 && clickedUser !== '')) &&
				<TableCell padding='checkbox'>
					<Checkbox
						color='primary'
						inputProps={{
							'aria-labelledby' : ''
						}}
						checked={isSelected?.includes(data?.folderId)}
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && handleCheckBox(data); }}
						onClick={() => handleCheckBox(data)}
					/>
				</TableCell>}
				<TableCell style={{ minWidth: 400, maxWidth: 400 }}>
					<div className='flexRow'>
						<div className='flexAutoRow alignCntr'>
							{Object.keys(data)?.length > 0 &&
							(data?.type === 0 || (tab === 2 && clickedUser === ''))
								? <BsFolder style={{ color: 'primary' }} className='primaryTxt' fontSize='var(--pixel24)'/>

								: <div className={`imgAvatarXS ${extensionformat !== 'zip' ? 'pointer' : ''} videothumb`}>
									{fileType !== 'video' && extensionformat !== 'zip'
										? <div className='imgAvatarXS brdrRadiusXSM avatarBgColor' >
											<LazyLoadImage
												src={fileType === 'image' ? data?.media?.url : defaultCheck.includes(extensionformat) ? '/documents/blank.png' : `/documents/${extensionformat}.png`}
												alt='images'
												className='brdrRadiusXSM'
												delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
												effect={process.env.REACT_APP_EFFECT}
												width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
											/>
										</div>
										: extensionformat === 'zip'
											? <MdOutlineFolderZip fontSize={'var(--pixel24)'} color='#F4B446'/>
											: !documentCheck.includes[extensionformat]
												?													<ReactPlayer url={data?.media?.url} className='reactPlayerWidth' width={'var(--percent100)'} height={'var(--percent100)'} />

												: (
													<LazyLoadImage
														src={`/documents/${extensionformat}.png`}
														alt='document'
														delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME} effect={process.env.REACT_APP_EFFECT} width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
													/>
												)
									}

								</div>
							}
						</div>
						<div className='flexAutoCol pdngLSM'>
							<span tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && tab !== 3 && setClickedData(data); tab !== 3 && handleClickFolder(data); }} className={`titleHeading headingMD ellipsisTxt blacktxt edmMaxTxt ${tab === 3 ? '' : extensionformat !== 'zip' ? 'PrimaryHoverTxt primaryTxt pointer' : ''}`} onClick={() => { tab !== 3 && setClickedData(data); tab !== 3 && handleClickFolder(data); }}>
								{(tab === 2 && clickedUser === '') ? data?.ownerName : data?.name}
							</span>
							<span className='flexRow'>
								{(tab === 2 && clickedUser === '')
									? <span className='lightTxt'> {data?.count} Files</span>
									: <span className='lightTxt'>
										{/* {tab === 1 ? `${language.sharedBy}` : (tab === 2 ? `${language.uploadedBy}` : (tab === 3 ? `${language.movedBy}` : ''))}
										{tab === 1 ? data?.createdUser?.name : (tab === 2 ? `${data?.uploadedBy}` : (tab === 3 ? `${data?.ownerId}` : ''))}&nbsp; */}
										{tab === 1 ? `${language.sharedBy} ${data?.createdUser?.name}` : null}
										{/* #I3076 - added space between language and name */}
									</span>
								}
								{/* ONLY TIME n DATE OF THE FOLDER WILL COME */}
								{([ 0, 3 ]?.includes(tab) || (tab === 2 && clickedUser !== '')) && (
									<span className='minWidthDate lightTxt'>
										&nbsp;
										{[ 0, 1, 2 ].includes(tab)
											? medaiDriveDateDiff(data?.createdAt, new Date().valueOf())
											: medaiDriveDateDiff(data?.trashAt, new Date().valueOf())
										}
									</span>
								)}
							</span>
						</div>
						{data?.shareTo && data?.shareTo?.length > 0 &&
						<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ share: true }); }} className='flexAutoRow alignCntr pdngHSM pointer' onClick={() => handlePopup({ share: true })}>
							<AvatarGroup>
								{shareArr.slice(0, 3)?.map((item:any) => (
									(item?.id[0] === 'R' || item?.type === 'company internal employees')
										? <Avatar key={item?.id[0]} alt='img' sx={{ width: 'var(--pixel30)', height: 'var(--pixel30)' }}>
											<GroupUserSvgIcon/>
										</Avatar>
										: <Avatar key={item?.id[0]} alt='img' src='/images/icons/defaultUser.svg' sx={{ width: 'var(--pixel30)', height: 'var(--pixel30)' }}/>
								))}
							</AvatarGroup>
							{shareArr?.length > 3 &&
							<div className='flexAutoRow alignCntr pdngLSM'>
								<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ share: true }); }} className='imgAvatarSM pointer brdrRadius50 moreTxt iconBlock' onClick={() => handlePopup({ share: true })}>
									<span className='fontWeight capitalTxt'>+{shareArr?.length - 3}</span>
								</button>
							</div>
							}
						</button>
						}
					</div>
				</TableCell>
				<TableCell style={{ maxWidth: 280, minWidth: 280 }}>
					<div className='flexRow justifyEnd'>
						{tab === 3 &&
							<span className='pdngHXS minWidthDate lightTxt'>{language.remaining} {remainingDays} {language.days}</span>
						}
						{([ 1 ]?.includes(tab)) && <span className='minWidthDate lightTxt'>{medaiDriveDateDiff(data?.sharedAt, new Date().valueOf())}</span>}

						{([ 0, 1, 3, 4 ]?.includes(tab) || (tab === 2 && clickedUser !== '')) &&
						<button className={`${(mediaState?.selectedData?.length >= 1) ? 'disableMode' : ''} lightTxt pdngRSM pointer`} tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOptions(e, data); }} onClick={(event) => handleOptions(event, data)}>
							<MoreVertIcon/>
						</button>}
						{/* FOR EMPLOYEES TAB WE WANT ONLY THIS DELETE ICON BUTTON */}
						{(tab === 2 && clickedUser === '') && <button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setOptionsData(data); handlePopup({ trash: true }); }} className='lightTxt pdngRSM pointer' onClick={() => { setOptionsData(data); handlePopup({ trash: true }); }}><RiDeleteBinLine fontSize={'var(--pixel22)'}/></button>}
					</div>
				</TableCell>
			</TableRow>
			{ anchorEl && Object.keys(optionsData || {})?.length > 0 &&
			<Menu
				id='demo-positioned-menu'
				aria-label='demo-positioned-button'
				open={anchorEl && Boolean(Object.keys(optionsData || {})?.length > 0)}
				anchorEl={anchorEl}

				onClose={handleClose}
				PaperProps={{ MuiPaperPropsStyles }}
				transformOrigin={{
					vertical   : 'top',
					horizontal : 'right'
				}}
				anchorOrigin={{
					vertical   : 'bottom',
					horizontal : 'right'
				}}
			>
				{Object.keys(optionsData)?.length > 0 &&
				<ListMenu setMediaDrivePopup={setMediaDrivePopup} tab={tab} openShare={openShare} data={data} popups={popups} handlePopup={handlePopup} setPopups={setPopups} optionsData={optionsData} setOptionsData={setOptionsData} getFoldersData={getFoldersData} setAnchorEl={setAnchorEl}/>}
			</Menu>}
			<div className={popups.share ? 'overlaySlider fadeInOverlay' : ''} onClick={() => handlePopup({ share: false })}/>
			<div className={popups.share ? 'flexCol fxdSocialMediaSlider slideIn whiteBg' : 'flexCol fxdSocialMediaSlider whiteBg'}>
				{popups.share && <SharedInfo sharedSliderClose={() => handlePopup({ share: false })} data={data}/>}
			</div>
			{popups?.customize && <SelectTemplate handlePopup={handlePopup} popups={popups?.customize} from='edit' data={data} clickedUser={clickedUser}/>}
			{popups?.move && <MoveToFolder handlePopup={handlePopup} popups={popups} optionsData={optionsData} />}
			{popups?.restore && <RestorePopup handlePopup={handlePopup} popups={popups} restoreData={[ optionsData ]} setOptionsData={setOptionsData} />}
			{popups?.delete && <DeletePopUp handlePopup={handlePopup} folderData={optionsData} getTrashDataInfo={getTrashDataInfo}/> }
			{popups?.trash && <MoveToTrashPopUp handlePopup={handlePopup} folderData={optionsData} />}
			{popups?.rename && <RenameFolder handlePopup={handlePopup} renameData={optionsData} popups={popups}/>}
			{mediaDrivePopup?.length > 0 &&
			// <NewCreatePopUp open={Boolean(mediaDrivePopup?.length > 0)} handleClose={() => setMediaDrivePopup(false)} mediaDrivePopup={mediaDrivePopup}/>}
			<CreationFieldPopUp
				OpenPop
				handleClosePop={() => setMediaDrivePopup(false)}
				requestT={'driveUpload'}
				externalFile={mediaDrivePopup}
			/>
			}
		</>
	);
};

export default ListCard;